import { render, staticRenderFns } from "./atlas.vue?vue&type=template&id=7e5d70b9&scoped=true&"
import script from "./atlas.vue?vue&type=script&lang=js&"
export * from "./atlas.vue?vue&type=script&lang=js&"
import style0 from "./atlas.vue?vue&type=style&index=0&id=7e5d70b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5d70b9",
  null
  
)

export default component.exports